
jQuery(document).ready(function(){
    jQuery(".video-section__poster").click();
    jQuery(document).on('click', '[data-ele="faq-question"]', function(){
      var _this = jQuery(this);
      var itemsWrapper = _this.parents('[data-ele="faq-items-wrapper"]');
      var itemWrapper = _this.parents('[data-ele="faq-item-wrapper"]');
      itemsWrapper.find('[data-ele="faq-question"]');
      itemWrapper.find('[data-ele="faq-question"]').parent('[data-ele="faq-item-wrapper"]').siblings().find('[data-ele="faq-question"]').removeClass("active");
      itemWrapper.find('[data-ele="faq-question"]').parent('[data-ele="faq-item-wrapper"]').siblings().find('[data-ele="faq-answer"]').slideUp();
      itemWrapper.find('[data-ele="faq-answer"]').slideToggle();
      _this.toggleClass('active');
    })
  
    jQuery("[data-ele='address-form'] .close-address-form").click(function(){
      jQuery("[aria-expanded='true']").attr("aria-expanded", "false")
    })

    jQuery(window).on("load scroll", function () {
      var scrollToBe = 0,
        element = jQuery('[data-ele="taxi-image-parallax"]'),
        winScrollTop = jQuery(window).scrollTop(),
        winHeight = jQuery(window).innerHeight(),
        docHeight = jQuery(document).innerHeight(),
        footerHeight = jQuery('footer').outerHeight(),
        maxScrollTop = docHeight - winHeight,
        elementOffeset = element.offset().top,
        leftScrollFromElementOffset = (parseInt(docHeight) - parseInt(elementOffeset));
        
      if(leftScrollFromElementOffset < winHeight ){
        scrollToBe = leftScrollFromElementOffset;
      }else{
        scrollToBe = winHeight;
      }
      /*
      console.log('========================');
      console.log('winHeight:'+ winHeight);
      console.log('elementOffeset:'+ elementOffeset);
      console.log('docHeight:'+ docHeight);
      console.log('footerHeight:'+ footerHeight);
      console.log('winScrollTop:'+ winScrollTop);
      console.log('========================');
      */
      var containerWidth = ((winScrollTop + winHeight) -  (elementOffeset)) / (scrollToBe / 100);
      
      if(containerWidth > 100){
        containerWidth = 100;
      }
      if(containerWidth < 0){
        containerWidth = 0;
      }
      if((winScrollTop + winHeight) > elementOffeset){
        element.css("width",containerWidth+"%");
      }
      
      jQuery( ".parallax-image" ).each(function( index ) {
        var elementParallax = jQuery(this);
        var elementOffesetParalax = elementParallax.offset().top;
        var containerWidth2 = ((winScrollTop + winHeight) -  (elementOffesetParalax)) / (winHeight / 100);
       if((winScrollTop + winHeight) > elementOffesetParalax){
        var x = containerWidth2 + "px";
         $(this).css('transform', `translateY(${x})`);
        }
      });
    });

   
  })

  jQuery(window).on('load', function(){
      if (navigator.appVersion.indexOf("Win")!=-1){
        jQuery("body").addClass("windowOS");
      } 
      if (navigator.appVersion.indexOf("Mac")!=-1){
        jQuery("body").addClass("macOS");
      } 
  })
jQuery(window).on('scroll', function(){
   setTimeout(function() {
     jQuery(".loader_img").addClass("remove_loader_img");
   },5000)
})
window.addEventListener('DOMContentLoaded', (event) => {
   setTimeout(function() {
     jQuery(".loader_img").addClass("remove_loader_img");
   },5000)
});
jQuery(window).on('load resize', function(){
  var winWid = jQuery(window).width();
  var SliderWid = jQuery('#MainContent .red-border-text-slider [data-ele=swiper-css-carousel] [data-ele=swiper-wrapper]').innerWidth();
  if(winWid > SliderWid){
    jQuery("#MainContent .red-border-text-slider [data-ele=swiper-css-carousel]").css('min-width', winWid * 2 + 'px');
    jQuery('#MainContent .red-border-text-slider .carousel-inner-section.swiper-wrapper .swiper-slide.carousel-slide').css('flex', "1");
    jQuery('.section-text-slider.red-border-text-slider [data-ele="swiper-wrapper"]').addClass("active");
  }
  else{
    jQuery("#MainContent .red-border-text-slider [data-ele=swiper-css-carousel]").css('min-width', "unset");
    jQuery('#MainContent .red-border-text-slider .carousel-inner-section.swiper-wrapper .swiper-slide.carousel-slide').css('flex', "unset");
    jQuery('.section-text-slider.red-border-text-slider [data-ele="swiper-wrapper"]').removeClass("active");
  }
})
















